export const GUESTY_HELP_TROUBLESHOOTING_LOGIN_URL =
  'https://help.guesty.com/hc/en-gb/articles/9369852308509-Troubleshooting-Login-Issues';

export const GUESTY_REQUEST_A_DEMO_URL =
  'https://www.guesty.com/request-a-demo/';

export const GUESTY_USER_DATA_KEY = 'guesty_user_data';
